import type { DifficultyConfig, MotionType, Operator } from '@/types/models';

const clamp = (v: number, min: number, max: number) => Math.min(Math.max(v, min), max);

export function configFor(level: number): DifficultyConfig {
  const lvl = Math.max(0, Math.floor(level));

  const roundDurationSec = clamp(8.0 * Math.pow(0.92, lvl), 2.0, 8.0);
  const tileCount = clamp(3 + Math.floor(lvl / 2), 3, 10);
  const maxDots = clamp(6 + lvl, 6, 22);
  const numberMax = Math.floor(5 + lvl * 1.8);
  const distractorCount = lvl >= 8 ? lvl - 7 : 0;

  let operators: Operator[];
  if (lvl <= 3) operators = ['+'];
  else if (lvl <= 6) operators = ['+', '-'];
  else if (lvl <= 10) operators = ['+', '-', '×'];
  else operators = ['+', '-', '×', '÷'];

  let motion: MotionType;
  if (lvl <= 3) motion = 'fall';
  else if (lvl <= 7) motion = 'parabolic';
  else motion = 'mixed';

  return {
    level: lvl,
    roundDurationSec,
    tileCount,
    maxDots,
    numberMax,
    operators,
    motion,
    distractorCount
  };
}
